<template>
  <div>
    <section class="mbr-section mbr-parallax-background mbr-after-navbar" id="content5-v" data-rv-view="55"
             style="background-image: url(assets/images/bg-products.jpg); padding-top: 120px; padding-bottom: 120px;">

      <div class="mbr-overlay" style="opacity: 0.5; background-color: rgb(0, 0, 0);">
      </div>

      <div class="container text-center">
        <h3 class="mbr-section-title display-2">{{ data.title }}</h3>
        <div class="lead"></div>
      </div>
    </section>
    <div class="space-md"></div>
    <b-container>
      <b-row class="justify-content-md-center">
        <b-tabs content-class="mt-3" justified>
          <b-tab :title="data.tab_ia" active>
            <products-list :data="data.ia"></products-list>
          </b-tab>
          <b-tab :title="data.tab_na">
            <products-list :data="data.na"></products-list>
          </b-tab>
          <b-tab :title="data.tab_oi">
            <products-list :data="data.oi"></products-list>
          </b-tab>
        </b-tabs>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import ProductsList from "../components/ProductList";

export default {
  name: "Products",
  components: {ProductsList},
  data() {
    return {
      language: {},
      data: {},
      pt: {
        title: 'Produtos',
        tab_ia: 'Industria Alimentícia',
        tab_na: 'Nutrição Animal',
        ia: [
          {
            titulo: 'BR 01 - CREME DE MILHO',
            descricao: 'O Creme de milho da BRMILL Alimentos é a granulometria mais fina do processo de moagem de grãos selecionados e qualidade superior, com teor de amido elevado e seus atributos sensoriais característico do cereal.',
            finalidade: 'O produto é bastante versátil com inúmeras possibilidades de aplicações na indústria de alimentos, podendo ser utilizado como ingrediente, veículo e como substituto de outras farinhas ou fontes de amido para panificação, massas, molhos, temperos, doces, sopas, caldos, bolos e outros.',
            embalagens: 'Sacos de ráfia de 25kg, 50kg, em big bags ou a granel',
            url: 'br01-creme-de-milho.jpg',
          },
          {
            titulo: 'BR 02 – FUBÁ MIMOSO',
            descricao: 'O Fubá Mimoso é obtido a partir de grãos selecionados e qualidade superior, com\n' +
                'granulometria uniforme, teor de amido elevado e com atributos sensoriais\n' +
                'característicos do cereal',
            finalidade: 'O produto apresenta variadas possibilidades de aplicações na indústria alimentícia,\n' +
                'podendo ser utilizado na indústria de massas, sopas, formulados para bolos, caldos,\n' +
                'coloríficos, além de ser destinado à empresas empacotadoras para o mercado de\n' +
                'varejo e consumo doméstico',
            embalagens: 'Sacos de ráfia de 25kg, 50kg, em big bags ou a granel',
            url: 'br02-fuba-mimoso.jpg',
          },
          {
            titulo: 'BR 03 – FUBÁ ITALIANO',
            descricao: 'Produto com granulometria fina e uniforme, o BR 03 é obtido de grãos selecionados\n' +
                'e qualidade superior com elevado teor de amido e com atributos sensoriais\n' +
                'característicos do cereal',
            finalidade: 'Por sua característica de granulometria fina e uniforme, o produto é bastante\n' +
                'utilizado na formulação de coloríficos em razão da grande capacidade de absorção\n' +
                'de pigmentos, além disso, pode ser também empregado na elaboração de\n' +
                'condimentos, temperos, sopas, na extrusão para produção de snacks e salgadinhos\n' +
                'e por empresas empacotadoras para o mercado de varejo e consumo doméstico',
            embalagens: 'Sacos de ráfia de 25kg, 50Kg, em big bags ou a granel',
            url: 'br03-fuba-italiano.jpg',
          },
          {
            titulo: 'BR 04 – GRITS DE MILHO FINO',
            descricao: 'Grits de milho com granulometria fina e uniforme, o BR 04 é obtido de grãos\n' +
                'selecionados e qualidade superior, contém baixo teor de lipídeos, livre de finos (pó) e\n' +
                'com atributos sensoriais característicos do cereal',
            finalidade: 'O BR 04 é amplamente utilizado na extrusão de salgadinhos de milho, e pode ser\n' +
                'empregado também na fabricação de cervejas, proporcionando maior rendimento e\n' +
                'qualidade da espuma. O produto se adapta bem aos diferentes processos de produção\n' +
                'de cerveja e aos diversos tipos de equipamentos utilizados nas extrusão',
            embalagens: 'Sacos de ráfia de 25kg, 50kg, em big bags ou a granel',
            url: 'br04-grits-de-milho-fino.jpg',
          },
          {
            titulo: 'BR 05 – GRITS DE MILHO MÉDIO',
            descricao: 'Grits de milho com granulometria média e uniforme, o BR 05 é obtido a partir de grãos\n' +
                'selecionados e com qualidade superior, contém baixo teor de lipídeos, livre de finos (pó)\n' +
                'e com atributos sensoriais característicos do cereal',
            finalidade: 'O BR 05 é amplamente utilizado na extrusão de salgadinhos de milho, e pode ser\n' +
                'empregado também na fabricação de cervejas, proporcionando maior rendimento e\n' +
                'qualidade da espuma. O produto se adapta bem aos diferentes processos de produção\n' +
                'de cerveja e aos diversos tipos de equipamentos utilizados nas extrusão',
            embalagens: 'Sacos de ráfia de 25kg, 50kG, em big bags ou a granel',
            url: 'br05-grits-de-milho-medio.jpg',
          },
          {
            titulo: 'BR 06 – GRITS DE MILHO GROSSO',
            descricao: 'O BR 06 é o grits de milho com granulometria média a grossa, e é obtido a partir de\n' +
                'grãos selecionados e com qualidade superior. O produto tem coloração amarela\n' +
                'acentuada com pequena quantidade de pontos brancos, livre de finos (pó) e com\n' +
                'atributos sensoriais característicos do cereal',
            finalidade: 'O produto apresenta variadas possibilidades de aplicações na indústria alimentícia,\n' +
                'podendo ser utilizado na indústria de extrusão para produção de salgadinhos, cervejaria\n' +
                'e na laminação para produção de flocos para cuscuz. Além de ser destinado à\n' +
                'empresas empacotadoras para o mercado de varejo e consumo doméstico',
            embalagens: 'Sacos de ráfia de 25kg, 50kG, em big bags ou a granel',
            url: 'br06-grits-de-milho-medio.jpg',
          },
          {
            titulo: 'BR 07- XERÉM',
            descricao: 'O BR 07 é a canjiquinha da BRMILL Alimentos. Apresenta granulometria grossa e\n' +
                'uniforme, e é obtido a partir de grãos selecionados e com qualidade superior. O produto\n' +
                'tem coloração amarela acentuada com pequena quantidade de pontos brancos, livre de\n' +
                'finos (pó) e com atributos sensoriais característico do cereal',
            finalidade: 'O produto apresenta grãos maiores e uniformes, ideal para a flocagem na produção de\n' +
                'Flocão e também é destinado à empresas empacotadoras para o mercado de varejo e\n' +
                'consumo doméstico',
            embalagens: 'Sacos de ráfia de 25kg, 50kG, em big bags ou a granel',
            url: 'br07-xeren.jpg',
          },
          {
            titulo: 'BR 07- BIG',
            descricao: 'O BR 07 apresenta granulometria grossa e uniforme, maior que o BR 07, e é\n' +
                'obtido a partir de grãos selecionados e com qualidade superior. O produto tem\n' +
                'coloração amarela acentuada com pequena quantidade de pontos brancos, livre de\n' +
                'finos (pó) e com atributos sensoriais característicos do cereal.',
            finalidade: 'O produto apresenta grãos maiores e uniformes, ideal para a flocagem na\n' +
                'produção de Flocão e também é destinado à empresas empacotadoras para o\n' +
                'mercado de varejo e consumo doméstico.',
            embalagens: 'Sacos de ráfia de 50kG, em big bags ou a granel.',
            url: 'br07-big.jpg',
          },
          {
            titulo: 'BR 09 – CANJICA AMARELA',
            descricao: 'O BR 09 é a canjica nobre da BRMILL Alimentos, é produzida a partir de grãos\n' +
                'selecionados e de elevada pureza, são grãos degerminados, sem película e gérmen,\n' +
                'divididos em duas ou mais partes, de cor amarela acentuada, com atributos sensoriais\n' +
                'característicos do cereal',
            finalidade: 'Por sua característica uniforme, pureza e ter grãos em sua maioria dividido em duas\n' +
                'partes, a canjica BR 09 é ideal na fabricação de cereais matinais (Corn Flakes), na\n' +
                'fabricação de farinha para empanar e para indústrias de empacotamento com aplicação\n' +
                'final em receitas domésticas',
            embalagens: 'Sacos de ráfia de 25kg, 50kg, em big bags ou a granel',
            url: 'br09-canjica-amarela-nobre.jpg',
          },
          {
            titulo: 'BR 09B – CANJICA BRANCA',
            descricao: 'A canjica branca é um produto nobre, produzido a partir de grãos selecionados e de\n' +
                'elevada pureza, são grãos degerminados, sem película e gérmen, divididos em duas ou\n' +
                'mais partes, com atributos sensoriais característicos do cereal',
            finalidade: 'A canjica branca destina-se para indústrias de empacotamento com aplicação final em\n' +
                'receitas domésticas e para indústrias que promovem o cozimento e empacotam\n' +
                'produtos processados para consumo final',
            embalagens: 'Sacos de ráfia de 25kg, 50kG, big bags ou a granel',
            url: 'br09b-canjica-branca.jpg',
          },
          {
            titulo: 'BR 10 – CANJICÃO',
            descricao: 'O BR 10 é o canjicão da BRMILL Alimentos, produzido a partir de grãos selecionados e\n' +
                'de elevada pureza, o produto é constituído por grãos inteiros, degerminados, sem\n' +
                'películas, de cor amarela acentuada, com atributos sensoriais característicos do cereal',
            finalidade: 'O BR 10 é o principal ingrediente para a indústria de expansão de pipocas doces,\n' +
                'salgadas, caramelizadas e outros sabores',
            embalagens: 'Sacos de ráfia de 25kg, 50kG, em big bags ou a granel',
            url: 'br10-canjicao.jpg',
          },
          {
            titulo: 'BR 10B – CANJICÃO BRANCO',
            descricao: 'O BR 10B é o canjicão branco da BRMILL Alimentos, é um produto nobre e de\n' +
                'qualidade superior, produzido a partir de grãos selecionados e de elevada pureza, o\n' +
                'produto é constituído por grãos inteiros, degerminados, sem películas, de cor\n' +
                'branca, com atributos sensoriais característicos do cereal',
            finalidade: 'O BR 10B é utilizado como ingrediente para a indústria de expansão de pipocas\n' +
                'doces, salgadas, caramelizadas e outros sabores, e também por indústrias de\n' +
                'empacotamento com aplicação final em receitas domésticas ou cozimento e\n' +
                'empacotamento de produtos processados para consumo final',
            embalagens: 'Sacos de ráfia de 25kg, 50 kG, em big bags',
            url: 'br10b-canjicao-branco.jpg',
          },
          {
            titulo: 'BRFloc',
            descricao: 'O BRFloc é o flocos de milho da BRMILL Alimentos, produzido a partir de grãos de\n' +
                'milho convencional selecionados, degerminados, moídos e laminados',
            finalidade: 'Ideal para elaboração de receitas tradicionais da culinária brasileira, como Cuscuz,\n' +
                'bolos e pode ser utilizado também como farinha para empanar',
            embalagens: 'Sacos de ráfia 35 Kg e Big Bags',
            url: 'flocos.jpg',
          },
          {
            titulo: 'BRFiber',
            descricao: 'BRFiber é a fibra de milho da BRMILL Alimentos, produzido a partir de grãos de\n' +
                'milho convencional selecionados e degerminados. Após a degerminação a fração\n' +
                'fibra é separada por meio de canais de aspiração e é moída',
            finalidade: 'Por ser um alimento funcional o BRfiber pode ser utilizado como ingrediente para\n' +
                'barra de cereais , biscoitos integrais, farinhas e suplementos de fibras',
            embalagens: 'Sacos de ráfia 20 Kg',
            url: 'brfiber-fibrademilho.jpg',
          },
          {
            titulo: 'BRMais',
            descricao: 'É o grão de milho amarelo convencional, inteiro da BRMILL Alimentos.\n' +
                'São grãos selecionados, limpos e classificados, de alta qualidade fitossanitária e\n' +
                'nutricional',
            finalidade: 'Por ser grão selecionados e de qualidade superior, são utilizados na elaboração de\n' +
                'arepas, tortilhas, nachos, farinhas integrais, entre outras receitas que utilizam a grão\n' +
                'integral',
            embalagens: 'Sacos de polipropileno tipo ráfia 50 Kg e Big Bags',
            url: 'brmais.jpg',
          },
          {
            titulo: 'BRMaisB',
            descricao: 'É o grão de milho branco, inteiro da BRMILL Alimentos. São grãos\n' +
                'selecionados, limpos e classificados, de alta qualidade fitossanitária e nutricional',
            finalidade: 'Por ser grão selecionados e de qualidade superior, são utilizados na elaboração de\n' +
                'arepas, tortilhas, nachos, farinhas integrais, entre outras receitas que utilizam a grão\n' +
                'integral branco',
            embalagens: 'Sacos de polipropileno tipo ráfia 50 Kg e Big Bags',
            url: 'brmaisb.jpg',
          },

        ],
        na: [
          {
            titulo: 'BRNUTRI – GÉRMEN DE MILHO',
            descricao: 'O gérmen de milho da BRMILL Alimentos é obtido a partir do processo de\n' +
                'degerminação dos grãos separando o endosperma do embrião e do pericarpo\n' +
                '(película), é livre de contaminantes e sujidades. O Gérmen integral de milho é rico\n' +
                'em lipídeos, proteína, minerais e fibra alimentar',
            finalidade: 'O BRNutri por conter elevado teor de lipídeos, aminoácidos, minerais e fibras e é\n' +
                'destinado principalmente para indústrias de ração, como excelente ingrediente na\n' +
                'formulação de ração para bovinos, suínos, aves, peixes e outros animais\n' +
                '\n' +
                'domésticos. Apresenta alta digestibilidade da proteína e maior biodisponibilidades\n' +
                'de aminoácidos essenciais e de minerais. O gérmen de milho é destinado também\n' +
                'para extração do óleo de milho',
            embalagens: 'Sacos de ráfia de 40kG, em big bags ou a granel',
            url: 'brnutri-germem-de-milho.jpg',
          },
          {},// O mesmo do item 13 do ia
          {},// O mesmo do item 6 do ia 14
        ]
      },
      en: {
        title: 'Products',
        tab_ia: 'Food industry',
        tab_na: 'Animal nutrition',
        ia: [
          {
            titulo: 'BR 01 – FINE CORN FLOUR',
            descricao: 'The Fine Corn Flour has the finest granulation obtained during the milling process\n' +
                'with high quality grains. It has a high starch content and its sensory attributes is\n' +
                'typical of this cereal.',
            finalidade: 'The product is very versatile with numerous possibilities for its applications in the\n' +
                'food industry which can be used as an ingredient and also as a substitute for other\n' +
                'flours or sources of starch for the baking process, production of pasta, sauces,\n' +
                'spices, sweets, soups, broths, cakes and others.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in\n' +
                'bulk.',
            url: 'br01-creme-de-milho.jpg',
          },
          {
            titulo: 'BR 02 – CORN MEAL',
            descricao: 'The Corn Meall is obtained from high quality grains, with an uniform size, high starch\n' +
                'content and with its sensory attributes typical of this cereal.',
            finalidade: 'The product has various possible applications in the food industry. It may be used in\n' +
                'the production of pasta, soups, cakes mixtures, soups, colorifics, and it can also be\n' +
                'directed to packing industries for the retail businesses and domestic consumption\n' +
                'market.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in\n' +
                'bulk.',
            url: 'br02-fuba-mimoso.jpg',
          },
          {
            titulo: 'BR 03 – COARSE CORN MEAL',
            descricao: 'A product with uniform grain size which is obtained from high quality grains, high\n' +
                'starch content and with its sensory attributes typical of this cereal.',
            finalidade: 'Due to its typically fine and uniform grain size, it is widely used in the formulation of\n' +
                'colorifics due to its high capacity to absorb pigments. Furthermore it may also be\n' +
                'used in the preparation of condiments, spices, soups, extrusion for the production of\n' +
                'snacks and packing industries for the retail businesses and domestic consumption\n' +
                'market.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in\n' +
                'bulk.',
            url: 'br03-fuba-italiano.jpg',
          },
          {
            titulo: 'BR 04 – FINE CORN GRITS',
            descricao: 'The Corn Grits with fine and uniform grain size is obtained from high quality grains which\n' +
                'contains low levels of lipids, powder free and with sensory attributes typical of this cereal.',
            finalidade: 'The BR 04 is widely used in the extrusion of corn snacks, and can also be used in\n' +
                'brewery industries, providing greater yield and quality of the foam. The product adapts\n' +
                'well to different brewing processes and to the various types of equipment used in the\n' +
                'extrusion.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br04-grits-de-milho-fino.jpg',
          },
          {
            titulo: 'BR 05 – CORN GRITS',
            descricao: 'The Corn Grits with an average and uniform size grain is obtained from high quality\n' +
                'grains which contains low levels of lipids, powder free and with sensory attributes typical\n' +
                'of this cereal.',
            finalidade: 'The BR 05 is widely used in the extrusion of corn snacks, and can also be used in\n' +
                'brewery industries, providing greater yield and quality of the foam. The product adapts\n' +
                'well to different brewing processes and to the various types of equipment used in the\n' +
                'extrusion.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br05-grits-de-milho-medio.jpg',
          },
          {
            titulo: 'BR 06 – COARSE CORN GRITS',
            descricao: 'The BR 06 is the corn grits with a grain size that vary from average to thick and is\n' +
                'obtained from high quality grains. The product has a sharp yellow color with a small\n' +
                'quantity of white spots, powder free and with sensory attributes typical of this cereal.',
            finalidade: 'The product has various possibilities for applications in the food industry and can be\n' +
                'used in extrusion process for the production of snacks, brewery industries and for the\n' +
                'lamination process of the flakes for couscous. It is also destined for packing industries for\n' +
                'the retail businesses and domestic consumption market.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br06-grits-de-milho-medio.jpg',
          },
          {
            titulo: 'BR 07- EXTRA COARSE CORN GRITS',
            descricao: 'The BR 07 features a thick and uniform grain size, and is obtained from high quality\n' +
                'grains. The product has a sharp yellow color with a small quantity of white spots, powder\n' +
                'fee and with sensory attributes typical of this cereal.',
            finalidade: 'The product features uniform and thicker grains ideal for flocking in the production of\n' +
                'flakes and is also destined for the packing industries for the retail businesses and\n' +
                'domestic consumption Market.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br07-xeren.jpg',
          },
          {
            titulo: 'BR 07- BIG',
            descricao: 'The BR 07 Big features a thicker and uniform grain size than BR07, and is obtained\n' +
                'from high quality grains. The product has a sharp yellow color with a small quantity\n' +
                'of white spots, powder fee and with sensory attributes typical of this cereal.',
            finalidade: 'The product is suitable for the extrusion of snacks, flocking in the production of\n' +
                'flakes and is also destined for the packing industries for the retail businesses and\n' +
                'domestic consumption Market.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in\n' +
                'bulk.',
            url: 'br07-big.jpg',
          },
          {
            titulo: 'BR 09 – FLAKING GRITS',
            descricao: 'The BR 09 is the noble corn flaking grits of BRMILL Alimentos. It is produced from select\n' +
                'grains with high purity which are dehusked and degerminated, divided into two or more\n' +
                'parts, with a sharp yellow color and with sensory attributes typical of this cereal.',
            finalidade: 'Due to its uniform and purity feature and also since it is mostly divided into two parts, the\n' +
                'flaking grits BR 09 is ideal for the production of breakfast cereals (Corn Flakes),\n' +
                'manufacture of flour for breading and for packing industries with final application in\n' +
                'domestic recipes.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br09-canjica-amarela-nobre.jpg',
          },
          {
            titulo: 'BR 09B – WHITE HOMINY',
            descricao: 'The BR 09B is the noble white hominy of BRMILL Alimentos. It is produced from\n' +
                'selected grains with high purity which are dehusked and degerminated, divided into two\n' +
                'or more parts, with a sharp yellow color and with sensory attributes typical of this cereal.',
            finalidade: 'The white hominy is intended for packing industries with final application to domestic\n' +
                'recipes and to industries that promote baking and also pack processed food for final\n' +
                'consumption.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br09b-canjica-branca.jpg',
          },
          {
            titulo: 'BR 10 – WHOLE DEGERMED CORN',
            descricao: 'The BR 10 is the whole degermed corn of BRMILL Alimentos, produced from select\n' +
                'grains with high purity. The product consists of whole grains which are degermed,\n' +
                'dehusked, with a sharp yellow color and with sensory attributes typical of this cereal.',
            finalidade: 'The BR 10 is the main ingredient for expanded popcorn industries (sweet, caramelized\n' +
                'salty, among other flavours popcorn) and packing industries for the retail businesses and\n' +
                'domestic consumption market.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br10-canjicao.jpg',
          },
          {
            titulo: 'BR 10B – WHOLE DEGERMED CORN – WHITE',
            descricao: 'The BR 10B is the whole degermed corn of BRMILL Alimentos, produced from select\n' +
                'grains with high purity. The product consists of whole white grains which are degermed,\n' +
                'dehusked and with sensory attributes typical of this cereal.',
            finalidade: 'The BR 10 is the main ingredient for expanded popcorn industries (sweet, caramelized,\n' +
                'salty, among other flavours of popcorn) and packing industries for the retail businesses\n' +
                'and domestic consumption market for the production of the traditional dish “cachupa”.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'br10b-canjicao-branco.jpg',
          },
          {
            titulo: 'BRFloc',
            descricao: 'Corn flakes produced from selected conventional grains, degerminated, milled and\n' +
                'laminated.',
            finalidade: 'Ideal for the preparation of traditional Brazilian recipes such as\n' +
                'Couscous, cakes and it may be use as a breading flour.',
            embalagens: 'Polypropylene bags (Raffia) of 35kg and Big Bags.',
            url: 'flocos.jpg',
          },
          {
            titulo: 'BRFiber',
            descricao: 'BRFiber is the fiber extracted from the corn, produced from selected grains with high\n' +
                'quality. It features a fine granulation with high fiber and lipids content and low\n' +
                'carbohydrate,with its sensory attributes typical of corn.',
            finalidade: 'The product has several potential applications in the food industry and can be used for\n' +
                'the production of breakfast cereals, cereal bar, food enrichment, cookies, bakeries,\n' +
                'pastries and packing industries for the retail businesses and domestic consumption\n' +
                'market.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'brfiber-fibrademilho.jpg',
          },
          {
            titulo: 'BRMais',
            descricao: 'Conventional yellow corn grain. Selected, clean and classified grains of\n' +
                'high phytosanitary and nutritional quality.',
            finalidade: 'Due to its strict selection it is mainly used for the production of\n' +
                'wholegrain flour, arepas, tortillas, nachos, among other recipes that requires the use\n' +
                'of whole corn.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs and big bags.',
            url: 'brmais.jpg',
          },
          {
            titulo: 'BRMaisB',
            descricao: 'Conventional white corn grain. Selected, clean and classified grains of\n' +
                'high phytosanitary and nutritional quality.',
            finalidade: 'Due to its strict selection it is mainly used for the production of\n' +
                'wholegrain flour, arepas, tortillas, nachos, among other recipes that requires the use\n' +
                'of whole corn.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs and big bags.',
            url: 'brmaisb.jpg',
          },

        ],
        na: [
          {
            titulo: 'BRNUTRI – CORN GERM',
            descricao: 'The BRMILL Alimentos corn germ is obtained from degermination process of the\n' +
                'corn by separating the endosperm from the embryo and pericarp (film), it is free of\n' +
                'contaminants and impurities. The corn germ is rich on lipids, protein, minerals and\n' +
                'dietary fiber.',
            finalidade: 'Due to the fact that the BRNutri contains high levels of lipids, amino acids, minerals\n' +
                'and fibers it is primarily intended for the feed industries, as an excellent ingredient in\n' +
                'the formulation of food for cattle, pigs, poultry, fish and other domestic animals. It\n' +
                'shows high digestibility of the protein and higher bioavailabilities of essential amino\n' +
                'acids and minerals. The corn germ is also intended for corn oil extraction.',
            embalagens: 'Polypropylene bags (Raffia) of 22,7 kgs, 25 kgs, 50kgs, big bags or in bulk.',
            url: 'brnutri-germem-de-milho.jpg',
          },
          {},
          {},
        ]
      },
      es: {
        title: 'PRODUCTOS',
        tab_ia: 'Industria Alimentar',
        tab_na: 'Nutrición animal',
        ia: [
          {
            titulo: 'BR 01 – HARINA DE MAÍZ EXTRA FINA',
            descricao: 'La harina de maíz BR01 es la más fina granulometría proveniente del proceso de molienda de granos seleccionados y de calidad superior, con un alto contenido de almidón y sus atributos sensoriales característicos del cereal.',
            finalidade: 'El producto es bastante versátil con innumerables posibilidades de aplicaciones en la industria de alimentos, donde puede ser utilizado como un ingrediente y como sustituto de otras harinas o fuentes de almidón para panadería, pasta, salsas, sazones, dulces, sopas, caldos, tortas y otros.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br01-creme-de-milho.jpg',
          },
          {
            titulo: 'BR 02 – HARINA DE MAÍZ',
            descricao: 'La harina de maíz se obtiene de granos selecionados y de calidad superior, con granulometría uniforme, alto contenido de almidón y atributos sensoriales característicos del cereal.',
            finalidade: 'El producto presenta variadas posibilidades de aplicaciones en la industria alimentar, pudiendo utilizarse en la industria de pastas, sopas, formulados para tortas, caldos, coloríficos, además de destinarse a empresas empaquetadoras para el mercado mayorista y consumo doméstico.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br02-fuba-mimoso.jpg',
          },
          {
            titulo: 'BR 03 – HARINA DE MAÍZ GRUESA',
            descricao: 'Producto de granulometría fina y uniforme, el BR 03 eres obtenido a partir de granos seleccionados y de calidad superior con alto contenido en almidón y con atributos sensoriales característicos del cereal.',
            finalidade: 'Por su característica de granulometría fina y uniforme, el producto es bastante utilizado en la formulación de coloríficos en razón de la gran capacidad de absorción de pigmentos. Además, también puede ser utilizado en la elaboración de condimentos, sazones, sopas, en la extrusión para producción de snacks y por empresas empaquetadoras para el mercado mayorista y consumo doméstico.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br03-fuba-italiano.jpg',
          },
          {
            titulo: 'BR 04 – SÉMOLA DE MAÍZ FINA',
            descricao: 'Sémola de maíz de granulometría fina y uniforme, el BR 04 eres obtenido de granos seleccionados y de calidad superior, bajo contenido de lípidos, libre de finos (polvo) y con atributos sensoriales característicos del cereal.',
            finalidade: 'El BR 04 es ampliamente utilizado en la extrusión de snacks de maíz y también puede ser utilizando en la fabricación de cervezas, proporcionando mayor rendimiento y calidad a la espuma. El producto se adapta bien a los diferentes procesos de producción de cerveza y a los diversos tipos de equipos utilizados en la extrusión.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br04-grits-de-milho-fino.jpg',
          },
          {
            titulo: 'BR 05 – SÉMOLA DE MAÍZ',
            descricao: 'Sémola de maíz de granulometría media y uniforme, el BR 05 eres obtenido de granos seleccionados y calidad superior, bajo contenido de lípidos, libre de finos (polvo) y con atributos sensoriales característicos del cereal.',
            finalidade: 'El BR 05 es ampliamente utilizado en la extrusión de snacks de maíz y también puede ser utilizando en la fabricación de cervezas, proporcionando mayor rendimiento y calidad a la espuma. El producto se adapta bien a los diferentes procesos de producción de cerveza y a los diversos tipos de equipos utilizados en la extrusión.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br05-grits-de-milho-medio.jpg',
          },
          {
            titulo: 'BR 06 – SÉMOLA DE MAÍZ – GRUESA',
            descricao: 'El BR 06 eres una sémola de maíz de granulometría media a gruesa, y se obtiene a partir de granos seleccionados de calidad superior. El producto tiene un color amarillo acentuado con una pequeña cantidad de puntos blancos, libre de finos (polvo) y con atributos sensoriales característicos del cereal.',
            finalidade: 'El producto presenta variadas posibilidades de aplicaciones en la industria alimentar, pudiendo ser utilizado en la industria de extrusión para producción de snacks, cervecería y en la laminación para producción de copos para cuscús. Además de destinarse a la empresas empaquetadoras para el mercado mayorista y consumo doméstico.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br06-grits-de-milho-medio.jpg',
          },
          {
            titulo: 'BR 07 – SÉMOLA DE MAÍZ EXTRA GRUESA',
            descricao: 'El BR 07 presenta una granulometría gruesa y uniforme y eres obtenido a partir de granos seleccionados de calidad superior. El producto tiene un color amarillo acentuado con una pequeña cantidad de puntos blancos, libre de finos (polvo) y con atributos sensoriales característicos del cereal.',
            finalidade: 'El producto presenta granos mayores y uniformes, ideal para la producción de copos de maíz y también se destina para empresas empaquetadoras para el mercado mayorista y para consumo doméstico.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br07-xeren.jpg',
          },
          {
            titulo: 'BR 07- BIG - GRITS DE MAÍZ EXTRA GRUESO',
            descricao: 'El BR 07 tiene una granulometría gruesa y uniforme (granos mayores que el BR 07) y eres obtido a partir de granos seleccionados de calidad superior. El producto tiene un color amarillo acentuado con una pequeña cantidad de puntos blancos, libre de finos (polvo) y con atributos sensoriales característicos del cereal.',
            finalidade: 'El producto tiene granos más grandes y uniformes, ideal para flocado en la producción de hojuelas de maíz y también se destina para empresas empaquetadoras para el mercado mayorista y para consumo doméstico.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br07-big.jpg',
          },
          {
            titulo: 'BR 09 – MAÍZ TRILLADO',
            descricao: 'El BR 09 es el maíz noble de BRMILL Alimentos, producido a partir de granos seleccionados y de alta pureza. Granos desgerminados, sin piel y sin germen, divididos en dos o más partes, de color amarillo acentuado, con atributos sensoriales característicos del cereal.',
            finalidade: 'Por su característica uniforme con alta pureza y granos en su mayoría divididos en dos partes, el maíz trillado BR 09 es ideal para la fabricación de cereales matinales (Cornflakes)/ Copos de Maíz, en la fabricación de harina para empanar y para industrias de empaques con aplicación final en recetas domésticas.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br09-canjica-amarela-nobre.jpg',
          },
          {
            titulo: 'BR 09B – MAÍZ TRILLADO BLANCO',
            descricao: 'El maíz trillado blanco es un producto noble, producido a partir de granos seleccionados y de gran pureza, son granos desgerminados, sin piel y sin germen, divididos en dos o más partes, con atributos sensoriales característicos del cereal.',
            finalidade: 'El maíz trillado blanco se destina a las industrias de empaques con aplicación final en recetas domésticas y para industrias que promueven el cocido y empaque de productos procesados para consumo final.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br09b-canjica-branca.jpg',
          },
          {
            titulo: 'BR 10 – MAÍZ ENTERO DESGERMINADO',
            descricao: 'Maíz entero desgerminado, producido a partir de granos seleccionados y de elevada pureza. El producto es constituido por granos enteros, desgerminados, sin películas, de color amarillo acentuado, con atributos sensoriales característicos del cereal.',
            finalidade: 'Es el ingrediente principal para la industria de palomitas expandidas dulces, saladas, caramelizadas y de otros sabores.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br10-canjicao.jpg',
          },
          {
            titulo: 'BR 10B – MAÍZ ENTERO BLANCO DESGERMINADO',
            descricao: 'Maíz entero desgerminado, producido a partir de granos seleccionados y de elevada pureza. El producto es constituido por granos enteros, desgerminados, sin películas, de color blanco, con atributos sensoriales característicos del cereal.',
            finalidade: 'Es el ingrediente principal para la industria de palomitas expandidas dulces, saladas, caramelizadas y de otros sabores y también eres usado por industrias de empaques y para aplicación final en recetas domésticas como la “cachupa”.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'br10b-canjicao-branco.jpg',
          },
          {
            titulo: 'BRFloc – HOJUELAS DE MAÍZ',
            descricao: 'BRFloc son las hojuelas de maíz producidas a partir de granos de maíz convencionales seleccionados, desgerminados, molidos y laminados.',
            finalidade: 'Ideal para preparar recetas tradicionales de la cocina brasileña, como cuscús, tortas y también se puede utilizar como harina para empanados.',
            embalagens: 'Bolsas de 35kg y Big Bags',
            url: 'flocos.jpg',
          },
          {
            titulo: 'BRFIBER',
            descricao: 'Fibra de maíz producida a partir de granos de maíz convencionales seleccionados y desgerminados. Después de la desgerminación, la fracción de fibra se separa a través de canales de succión y se muele.',
            finalidade: 'El producto tiene varias aplicaciones potenciales en la industria alimentar y puede ser utilizado en industrias de cereales matinales, barras de cereales, enriquecimiento de los alimentos, galletas, pasteles, panaderías y envasadores de productos alimenticios para el mercado mayorista y para consumo doméstico.',
            embalagens: 'Bolsas de 20kg',
            url: 'brfiber-fibrademilho.jpg',
          },
          {
            titulo: 'BRMais',
            descricao: 'Granos de maíz amarillo entero convencional. Son granos seleccionados, limpios y clasificados, de alta calidad fitosanitaria y nutricional.\n',
            finalidade: 'Por se tratar de granos seleccionados de calidad superior, eres utilizado en la elaboración de arepas, tortillas, nachos, harinas integrales, entre otras recetas que utilizan granos integrales.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'brmais.jpg',
          },
          {
            titulo: 'BRMaisB',
            descricao: 'Granos de maíz blanco entero convencional. Son granos seleccionados, limpios y clasificados, de alta calidad fitosanitaria y nutricional.',
            finalidade: 'Por se tratar de granos seleccionados de calidad superior, eres utilizado en la elaboración de arepas, tortillas, nachos, harinas integrales, entre otras recetas que utilizan granos integrales.',
            embalagens: 'Bolsas de 22,7kg, 25kg, 50kg, big bags o a granel',
            url: 'brmaisb.jpg',
          },

        ],
        na: [
          {
            titulo: 'BRNUTRI – GERMEN DE MAÍZ',
            descricao: 'El germen de maíz se obtiene del proceso de desgerminación del grano al separar el endospermo del embrión y el pericarpio (película), se encuentra libre de contaminantes y suciedad. El germen de maíz entero es rico en lípidos, proteínas, minerales y fibra dietética',
            finalidade: 'El BRNutri por tener elevado contenido de lípidos, aminoácidos, minerales y fibras se destina principalmente para industrias de ración, como excelente ingrediente en la formulación de ración para bovinos, porcinos, aves, peces y otros animales domésticos. Presenta alta digestibilidad de la proteína y mayor biodisponibilidades de aminoácidos esenciales y de minerales. El germen de maíz se destina también para extracción de aceite de maíz.',
            embalagens: 'Bolsas de 40kg, big bags o a granel',
            url: 'brnutri-germem-de-milho.jpg',
          },
          {},
          {},
          {},

        ]
      },
    }
  },
  mounted() {
    if (localStorage.language) {
      this.language = localStorage.language;
    } else {
      localStorage.setItem('language', 'pt');
      document.location.reload(true);
    }
    switch (this.language) {
      case 'en':
        this.data = this.en;
        break;
      case 'es':
        this.data = this.es;
        break;
      default:
        this.data = this.pt;
    }
    //Replica os produtos de industria alimentícia em Nutrição Animal e Outras Indústrias
    this.data.na[1] = this.getProduct(13)
    this.data.na[2] = this.getProduct(14)
    // this.data.na[3] = this.getProduct(14)
    // this.data.na[4] = this.getProduct(7)
    // this.data.na[5] = this.getProduct(14)
    // this.data.oi[0] = this.getProduct(1)
    // this.data.oi[1] = this.getProduct(4)
  },
  created: function () {
  },
  //
  methods: {
    getProduct: function (index) {
      return this.data.ia[index]
    }

  },
  // components: {ProductsList}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
